import {uniqueId} from 'lodash'

const columns = [
  {
    type: 'index',
    width: '22px'
  },
  {
    title: 'Project name',
    prop: 'name',
    route: {
      name: 'ProjectCard',
      paramName: 'projectId',
      paramValue: 'id'
    }
  },
  {
    title: 'Client',
    display: 'client.nickName',
    prop: 'client',
    route: {
      name: 'ListOfProjectByClient',
      paramName: 'clientId',
      paramValue: 'client.id'
    }
  },
  {
    title: 'Status',
    type: 'status',
    styles: 'tag',
    prefix: '#',
    prop: 'status.title',
    info: 'comments'
  },
  {
    title: 'Amount, AED',
    type: 'number',
    prop: 'factValue',
    className: true
  },
  {
    title: 'Started',
    prop: 'dateStart',
    type: 'date',
    pointer: true,
    sortBy: 'dateStart',
    width: 'minmax(92px, 0.5fr)'
  },
  {
    title: 'Last update',
    prop: 'dateLastUpdate',
    type: 'date',
    pointer: true,
    sortBy: 'dateLastUpdate',
    width: 'minmax(92px, 0.5fr)'
  },
  {
    title: 'PM',
    type: 'image',
    display: 'projectManager.image.path',
    popup: 'projectManager.username',
    prop: 'projectManager',
    defaultIcon: 'user'
  }
]

const prefix = 'col_financial_'
const financialPlanningColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export default financialPlanningColumns



// WEBPACK FOOTER //
// ./src/constants/TablesSettings/listOfFinancialPlanning.js